import { InfoOutlined } from '@maas-components/icons'
import { Typography } from '@material-ui/core'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import EanBarCodeImage from 'core/assets/images/ean-barcode.png'
import i18n from 'core/common/i18n'
import { IconButton, Callout, Text } from 'core/components/Core'
import Modal from 'core/components/Modal'

function ProductDialogTitleTips({ open, onClose }) {
  return (
    <Modal
      title={
        <div className="d-flex justify-between">
          <Typography variant="h5">
            {i18n.t('productNew.variationDetails.productEanTipsTitle')}
          </Typography>

          <IconButton
            size="small"
            onClick={onClose}
            aria-label={i18n.t('productNew.basicData.closeButtonAriaLabel')}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </div>
      }
      open={open}
      onCancel={onClose}
      maxWidth="md"
    >
      <div className="d-flex align-center">
        <img
          src={EanBarCodeImage}
          alt={i18n.t('productNew.variationDetails.productEanBarcodeAltText')}
          className="mr-3"
        />

        <Typography variant="body1" style={{ width: '80%' }}>
          {i18n.t('productNew.variationDetails.productEanTipsSubtitle')}
        </Typography>
      </div>

      <Callout color="primary" className="my-3 py-2 px-3" style={{ color: '#000' }}>
        <InfoOutlined fontSize="small" className="mr-1" color="primary" />
        <Typography component="span" variant="body2">
          <Text>{i18n.t('productNew.variationDetails.important')}</Text>
          <Text>{i18n.t('productNew.variationDetails.productEanNotice')}</Text>
        </Typography>
      </Callout>

      <Typography variant="body1">
        {i18n.t('productNew.variationDetails.productEanNotice2')}
      </Typography>
    </Modal>
  )
}

export default ProductDialogTitleTips
